<svelte:head>

    <title>Standorte • keyosh</title>

</svelte:head>

<script>
    import Locations from "../../components/onboarding/locations.svelte"
</script>


<section>

    <Locations />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

    @media screen and (max-width: 1024px) {

        section {
            flex-direction: column;
        }

    }

</style>
